export default "__VITE_ASSET__CcqPfTxv__"